import {observer} from 'mobx-react';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {OpenEndedQuestionEditStore} from '../OpenEndedQuestionEditStore';

@observer
export class OpenEndedQuestionTextArea extends React.Component<{ store: OpenEndedQuestionEditStore }> {
  render() {
    const store = this.props.store;

    return (
      <TextareaAutosize className="form-control"
                        value={store.serialized.value}
                        onChange={store.serialized.onChangeHandler}>
      </TextareaAutosize>
    );
  }
}
